module.exports = __webpack_public_path__ + "6df8039aacee3cfd95dc1d62fb3cddec.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-26.png
// module id = 2230
// module chunks = 0